// removed by extract-text-webpack-plugin
module.exports = {"btnWrapper":"_2ZYwJ0IZLvHBS_dRRKRixp","closeBtn":"_1m6b4LXmHu-MkxWiKIQc1B","mobile":"_3A-6XZRhtwJm3bbMmPXi3H"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CloseButton/CloseButton.scss
// module id = 1557
// module chunks = 0